import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from '@mui/material/styles';

import Box from '~/common/components/Box';
import Text from '~/common/components/Texts/Typography';
import colors from '~/theme/colors';

export const LeftDrawerLoanSummaryContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  box-sizing: border-box;
`;

export const LoaderStack = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const LoanSummaryBox = styled(Box)`
  width: 100%;
`;

export const CopyableTextStyle = {
  lineHeight: '2rem',
  fontWeight: '500',
  fontSize: '1.25rem',
};

export const RatioInfoStackStyle = styled(Box)`
  display: flex;
  justify-content: space-between;
  padding-top: 16px;
  padding-bottom: 16px;
  gap: 8px;
`;

export const RatioInfoBox = styled(Box)`
  width: 80px;
`;

export const RatioHeader = styled(Text)`
  color: ${colors.gray[900]};
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1rem;
`;

export const RatioValue = styled(Text)`
  color: ${colors.gray[900]};
  font-size: 1rem;
  font-weight: 500;
  line-height: 1rem;
`;

export const TooltipBox = styled(Box)`
  color: ${colors.gray[900]};
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1rem;
`;

export const TooltipRatioValue = styled(Box)`
  color: ${colors.gray[900]};
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1rem;
`;

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  color: ${colors.blue[500]};
`;

export const TooltipStyle = {
  background: '#FFF',
  borderRadius: '0.25rem',
  boxShadow: '0px 3px 6px rgba(0,0,0,0.16), 0px 3px 6px rgba(0,0,0,0.23)',
};

export const RatioHeaderBox = styled(Box)`
  display: flex;
  justify-content: space-between;
`;

export const RatioTooltipBox = styled(Box)`
  display: flex;
  width: 16px;
  height: 16px;
  justify-content: center;
  align-items: center;
`;
